import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DASHBOARD_MAIN_MENU_CONFIG } from '../constants/dashboard-main-menu-config';
import { MenuItemModel } from '../../../common/models';
import { IconNames } from '../../../common/constants';
import { Router } from '@angular/router';

@Component({
  selector: 'dashboard-nav-icons',
  templateUrl: './nav-icons.component.html',
  styleUrls: ['./nav-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavIconsComponent {
  menuStructure: MenuItemModel[] = DASHBOARD_MAIN_MENU_CONFIG;
  iconNameList = IconNames;

  @Input() activeMenuItem$: BehaviorSubject<string>;

  constructor(private router: Router) {}

  onMenuIconClick(menuElement: MenuItemModel): void {
    if (!menuElement.children) {
      const navigationString: string =
        menuElement.url === '/dashboard' ? menuElement.url : '/dashboard/' + menuElement.url;
      this.router.navigate([navigationString]);
    }
    this.activeMenuItem$.next(menuElement.title);
  }
}
